import { defineMessages } from 'react-intl';

export const clinicianTrialStartMessages = defineMessages({
  title: {
    defaultMessage: '14 days of the Clinician plan,\non us.',
    id: 'CDsVNOAyq9',
    description: 'Heading for the Clinician trial start modal',
  },
  subtitle: {
    defaultMessage:
      'Enjoy premium features for 14 days. No card needed. After 14 days, Heidi keeps working on the Free plan.',
    id: '7pEzKSAzN2',
    description: 'Supporting text for the Clinician trial start modal',
  },
  subtitleOptional: {
    defaultMessage:
      'After your trial you can continue using Heidi’s base plan for free, <bold>no card required</bold>.',
    id: 'awzef/+NhZ',
    description:
      'Supporting text for the optional Clinician trial start modal. <bold> wraps the phrase that should be emphasized.',
  },
  cta: {
    defaultMessage: 'Take me to Heidi',
    id: 'PkUQHaVzAk',
    description: 'Primary button in the Clinician trial start modal',
  },
  exploreLater: {
    defaultMessage: 'Explore later',
    id: '3uNl72Q3KW',
    description: 'Secondary button to dismiss the optional Clinician trial start modal',
  },
});

export const heidi2ClinicianTrialMessages = defineMessages({
  title: {
    defaultMessage:
      'You have {trialDays, plural, one {# day} other {# days}} of Clinician trial, on us!',
    id: 'mSieRKQmW5',
    description: 'Heading for the Heidi 2 Clinician trial start modal',
  },
  subtitle: {
    defaultMessage: 'You’ll then move to free if you do not choose to upgrade',
    id: '8Bn9z/Bhe/',
    description: 'Supporting text for the Heidi 2 Clinician trial start modal',
  },
  templatesFeature: {
    defaultMessage: 'Custom scribe templates',
    id: 'Xh+o/0i7jO',
    description: 'Template benefit in the Heidi 2 Clinician trial start modal',
  },
  adminTasksFeature: {
    defaultMessage: 'Try agents to handle work around the consult',
    id: 'TwZMj5FX6S',
    description: 'Agents usage benefit in the Heidi 2 Clinician trial start modal',
  },
  evidenceFeature: {
    defaultMessage: 'Evidence answers in patient sessions',
    id: 'ORc68ArWJa',
    description: 'Evidence benefit in the Heidi 2 Clinician trial start modal',
  },
  confirmButton: {
    defaultMessage: 'Got it',
    id: 'KvSFlsqL2J',
    description: 'Confirmation button in the Heidi 2 Clinician trial start modal',
  },
  footer: {
    defaultMessage:
      'At the end of your {trialDays}-day Clinician free trial, you’ll automatically go on the Free plan.',
    id: 'PDHYHyl+0U',
    description: 'Plan transition note in the Heidi 2 Clinician trial start modal',
  },
});
